<script lang="ts">
import Vue from "vue";
import { filter } from "lodash";
import { FIELD_TYPES } from "../../../field_types";
import CloseIcon from "vue-material-design-icons/Close.vue";

export default Vue.extend({
  name: "FieldsOutline",
  components: {
    CloseIcon,
  },
  props: {
    fields: { type: Array, default: () => [] },
  },
  computed: {
    visible_field_types() {
      return filter(FIELD_TYPES, "show");
    },
  },
  methods: {
    isRequired(field) {
      if ("required" in field) {
        return field.required;
      }
      return false;
    },
    deleteField(fields, index) {
      fields.splice(index, 1);
      this.$emit("fields-change", fields);
    },
    fieldsChanged(fields) {
      // pass on
      this.$emit("fields-change", fields);
    },
    hasFields(field) {
      return "fields" in field && field.fields.length > 0;
    },
    getIcon(field) {
      var type = this.visible_field_types.find(
        (t) => t.code === field.field_type
      );
      if (type) {
        return type.icon;
      }
      return null;
    },
  },
});
</script>

<template>
  <ul>
    <li v-for="(field, index) in fields" :key="field.name">
      <component :is="getIcon(field)" /> &nbsp;
      <span class="name">{{ field.name }}</span
      ><span class="text-danger" v-if="isRequired(field)">*</span>
      &nbsp;
      <span class="code">{{ field.code }}</span>
      &nbsp;
      <close-icon class="delete-btn" @click="deleteField(fields, index)" />

      <div v-if="hasFields(field)">
        <fields-outline
          :fields="field.fields"
          @fields-changed="fieldsChanged"
        ></fields-outline>
      </div>
    </li>
  </ul>
</template>

<style scoped>
.name {
  font-weight: bold;
}
.code {
  font-weight: lighter;
  color: #888;
}

.delete-btn {
  color: red;
  cursor: pointer;
}
</style>
